import {Popover} from './popover';

// Need to type props this way so TS knows which props have defaults and
// therefore are not required, also omitting noDefaultStyling to enforce it is
// set as true
type StyledPopoverProps = Omit<React.ComponentProps<typeof Popover>, 'noDefaultStyling'>;

export function StyledPopover({children, ...restProps}: StyledPopoverProps) {
    return (
        <Popover {...restProps} noDefaultStyling={true}>
            <div className='pad-16 background-white br-8 box-shadow'>{children}</div>
        </Popover>
    );
}
